import React from 'react'
import style from './index.module.less'

export default () => {
  return (
    <div className={style.wechat}>
      <h2 className="title">
        <img src="https://qnm.hunliji.com/o_1d4hsp0p71n9r1h0a1aes1kp217g81r.png" />玩转微信生态
      </h2>
      <div className="clearfix wechat-img-wrap">
        <div className="left-img-wrap">
          <div className={style['left-img']}>
            <img src="https://qnm.hunliji.com/o_1d4ng4u6b3u81fl61i991l45d0o1c.png" />
          </div>
          <p className="img-tip">商家分享小程序</p>
          <img
            className="xiaochengxu"
            src="https://qnm.hunliji.com/o_1d4ht662c1nr91dif1lc8107h14j72a.png"
          />
          <img
            className="qingtie"
            src="https://qnm.hunliji.com/o_1d4ht6rnk1mj1i851oi86t315kp2f.png"
          />
        </div>
        <div className="right-img-wrap">
          <img
            className="right-img"
            src="https://qnm.hunliji.com/o_1d4ht40d32t1u8uh27tns34j25.png"
          />
          <img
            className="weichuandan"
            src="https://qnm.hunliji.com/o_1d4ht7bsp161v1gfdhog16aoec52k.png"
          />
          <p className="img-tip">朋友圈营销/微传单活动</p>
        </div>
      </div>
    </div>
  )
}
